var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('cv-header',{staticClass:"header"},[_c('cv-header-name',{on:{"click":function($event){return _vm.$emit('modal:close')}}},[_c('ArrowLeft16')],1),_c('p',[_vm._v(_vm._s(_vm.$t('header.logo-upload')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }